(ns ycweb.weber.layout
  (:require
    [rum.core :as rum]
    [ycweb.weber.common :as cmn]))

;; Utility functions ----------------------------

(defn tab [name content]
  {:name name
   :id (cmn/idfy (str "tab_" name))
   :content content})

(defn tab-url [name url]
  {:name name
   :id (cmn/idfy (str "tab_" name))
   :content [(cmn/loadimg) " Loading..."]
   :url url})

;; RUM components -------------------------------

(rum/defc tablink [name url fortab current]
  [:li {:class [(when current :current)]}
   [:a {:href url :fortab fortab} name]])

#_[:div.pageheader
 [:h1.pagetitle "Dashboard"]
 [:span.pagedesc "This is a sample description of a page"]
 [:ul.hornav
  [:li.current [:a {:href "#updates"} "Updates"]]
  [:li [:a {:href "#activities"} "Activities"]]]]

(rum/defc tabbed-content [title description tabs]
  [:div.centercontent.notab
   [:div.pageheader
    [:h1.pagetitle title]
    [:span.pagedesc description]]


   [:div.contentwrapper
    (into
      [:div.tabs
       (into [:ul]
         (map
           (fn [{:keys [name url id] :as tab}]
             (tablink name (if url url (str "#" id)) id (= tab (first tabs))))
           tabs))]
      (->>
        tabs
        (remove nil?)
        (remove :url)
        (map
          (fn [{:keys [id url content] :as tab}]
            (into
              [:div.subcontent
               {:id id
                :loaded (if url "false" "true")}]
              (let [[fst & more] content]
                (if (keyword? fst) [content] content)))))))]])

(rum/defc content [title description content]
  [:div.centercontent
   [:div.pageheader.notab
    [:h1.pagetitle title]
    [:span.pagedesc description]]

   (into [:div.contentwrapper]
     (if (keyword? (first content)) [content] content))])

(defn column [content & [span]]
  {:content content
   :span (or span 1)
   :spanbase (["one" "two" "three" "four" "five"] (dec (or span 1)))})

(def legal-columns
  #{"one_half" "one_third" "two_third"
    "two_fourth" "three_fourth" "one_fourth" "one_fifth"
    "two_fifth" "three_fifth" "four_fifth" "one_sixth" "five_sixth"})

(defn columns [& cols]
  (let [colcnt (dec (count cols))
        spancnt (dec (reduce #(+ %1 (:span %2)) 0 cols))
        base (get ["_none" "_half" "_third" "_fourth" "_fifth" "_sixth"]  spancnt :not-found)
        mappedspans (map #(str (:spanbase %) base) cols)
        illegalspans (remove legal-columns mappedspans)]

    (cond
      (= base "_none")
      (into [:div] (:content (first cols)))

      (not-empty illegalspans)
      (throw
        #?(:clj  (RuntimeException. (str "Trying to use illegal column sizes: " (vec illegalspans)))
           :cljs (js/Error. (str "Trying to use illegal column sizes: " (vec illegalspans)))))

      :else
      (into
        [:div
         {:class [:container]
          :style {"overflow" "auto"}}]
        (map
          (fn [{c :content} class idx]
            (into
              [:div {:class [class (when (= idx colcnt) :last)]}]
              c))
          cols mappedspans (range))))))